import angular from 'angular';
import 'angular-ui-router';

export default angular.module('app.services.header', [
  'ui.router'
])
.service('header', function ($rootScope, $state) {
  let header = {};

  let onStateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function () {
    header.hasSecondary = /app\.((analytics|campaigns|segments)\.index|campaigns\.show|(analytics|campaigns)\.explore)/.test($state.$current.self.name);
    header.isSegments = /app\.segments\.index'/.test($state.$current.self.name);
  });

  $rootScope.$on('$destroy', onStateChangeSuccess);

  return header;
})


/** WEBPACK FOOTER **
 ** ./src/services/header.js
 **/